export default __webpack_public_path__ + "static/media/mitigation-main-level-air-mover.482c11d3.jpg";